import { render } from "./places.page.vue?vue&type=template&id=a1ccda2a"
import script from "./places.page.vue?vue&type=script&lang=js"
export * from "./places.page.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__